"use client";

import Image from "next/image";
import { useEffect, useState } from "react";

const IMAGES = ["/images/kritika-portrait-2.jpg", "/images/kritika-portrait.jpeg"];

export default function HeroPortrait() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % IMAGES.length);
    }, 4500);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="relative aspect-[3/4] w-full overflow-hidden border border-ink/14">
      {IMAGES.map((src, i) => (
        <Image
          key={src}
          src={src}
          alt="Kritika Virwal, Advocate"
          fill
          className={`object-cover transition-opacity duration-1000 ease-in-out ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
          priority={i === 0}
        />
      ))}
    </div>
  );
}
